import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  z-index: 1;\n  user-select: none;\n  pointer-events: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n      width: 30;\n      padding-left: 10;\n      background-color: transparent;\n      border-color: transparent;\n\n      &:focus {\n        width: ", "px;\n        padding-left: 30;\n        background-color: secondary-bg;\n        border-color: border;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: secondary-bg;\n  border-radius: 4;\n  border: 1;\n  border-color: border;\n  line-height: 1.4;\n  padding: 5 10 5 30;\n  color: text;\n  transition: base;\n  transition-property: all;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 3px 1px ", ";\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      width: 30;\n      z-index: 2;\n\n      svg {\n        color: text;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  svg {\n    color: border;\n    transition: base;\n    transition-property: color;\n  }\n\n  &:focus-within {\n    svg {\n      color: text;\n    }\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css, th, down } from '@xstyled/styled-components';
import SearchSolid from './icons/SearchSolid';
import { AlgoliaStyle } from './AlgoliaStyle';
var Container = styled.div(_templateObject(), down('md', css(_templateObject2())));
var Input = styled.input(_templateObject3(), th.color('primary'), down('md', css(_templateObject4(), function (p) {
  return p['data-width'];
})));
var SearchIcon = styled(SearchSolid)(_templateObject5());
export function DocSearch(_ref) {
  var apiKey = _ref.apiKey,
      indexName = _ref.indexName;
  var ref = React.useRef();

  var _React$useState = React.useState(),
      width = _React$useState[0],
      setWidth = _React$useState[1];

  React.useEffect(function () {
    var rect = ref.current.getBoundingClientRect();
    setWidth(window.innerWidth - rect.x - 20);
  }, []);
  React.useEffect(function () {
    window.docsearch({
      apiKey: apiKey,
      indexName: indexName,
      inputSelector: '#algolia-docsearch-input'
    });
  }, [apiKey, indexName]);
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref
  }, /*#__PURE__*/React.createElement(AlgoliaStyle, null), /*#__PURE__*/React.createElement(SearchIcon, null), /*#__PURE__*/React.createElement(Input, {
    type: "search",
    id: "algolia-docsearch-input",
    placeholder: "Search...",
    "data-width": width
  }));
}